exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content .row-data[data-v-34b63b78] {\n  margin-bottom: 20px;\n}\n.content .button-over[data-v-34b63b78] {\n  border-radius: 0;\n  margin-left: 3px;\n}\n.content .button-click[data-v-34b63b78] {\n  text-align: right;\n}\n.content .table-content .el-table[data-v-34b63b78] {\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  border: 1px solid #78a5e7;\n}\n.content .paging-click .el-pagination[data-v-34b63b78] {\n  text-align: right;\n  margin: 30px 0;\n}\n.content[data-v-34b63b78] .el-table td,\n.content[data-v-34b63b78] .el-table th {\n  padding: 6px 0;\n}\n", ""]);

// exports
